import { render } from "./tree-menu.vue?vue&type=template&id=a8641f0c&scoped=true"
import script from "./tree-menu.vue?vue&type=script&lang=js"
export * from "./tree-menu.vue?vue&type=script&lang=js"

import "./tree-menu.vue?vue&type=style&index=0&id=a8641f0c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8641f0c"]])

export default __exports__